import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLang);
  };

  return (
    <button onClick={toggleLanguage} className="language-toggle" title="Change Language">
      <Globe size={18} />
      <span>{i18n.language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageToggle;
